import { Dispatch, SetStateAction } from "react";
import { useIntl } from "react-intl";
import { Message, Segment, Table } from "semantic-ui-react";
import { TablePagination } from "../../components/TablePagination/TablePagination";
import { TranslateProps } from "../../i18n/TranslateProps";
import { changeLogTypeOptions, IChangeLogItem } from "../../models/changeLogItem";
import { formatDate } from "../../models/common";

type Props = {
    items: IChangeLogItem[];
    page: number;
    setPage: Dispatch<SetStateAction<number>>;
    totalRows: number;
};

export const ChangeLogICSTable = ({ items, page, setPage, totalRows }: Props) => {
    const intl = useIntl();

    return items.length === 0 ? (
        <Message icon="info circle" header={intl.formatMessage({ id: "noResultsFound" })} />
    ) : (
        <Segment>
            <Table basic="very">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell width={1} singleLine>
                            {intl.formatMessage({ id: "user" })}
                        </Table.HeaderCell>
                        <Table.HeaderCell width={1} singleLine>
                            {intl.formatMessage({ id: "firstName" })}
                        </Table.HeaderCell>
                        <Table.HeaderCell width={1} singleLine>
                            {intl.formatMessage({ id: "lastName" })}
                        </Table.HeaderCell>
                        <Table.HeaderCell width={1} singleLine>
                            {intl.formatMessage({ id: "timestamp" })}
                        </Table.HeaderCell>
                        <Table.HeaderCell width={1} singleLine>
                            {intl.formatMessage({ id: "qualificationID" })}
                        </Table.HeaderCell>
                        <Table.HeaderCell width={1} singleLine>
                            {intl.formatMessage({ id: "icNumber" })}
                        </Table.HeaderCell>
                        <Table.HeaderCell width={1} singleLine>
                            {intl.formatMessage({ id: "icsBewerber" })}
                        </Table.HeaderCell>
                        <Table.HeaderCell width={1} singleLine>
                            {intl.formatMessage({ id: "actions" })}
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {items.map(c => (
                        <Table.Row key={c.guid}>
                            <Table.Cell singleLine>{c.username || "EC"}</Table.Cell>
                            <Table.Cell singleLine>{c.firstName}</Table.Cell>
                            <Table.Cell singleLine>{c.lastName}</Table.Cell>
                            <Table.Cell singleLine>{formatDate(c.timestamp, true)}</Table.Cell>
                            <Table.Cell singleLine>{c.targetIcNumber}</Table.Cell>
                            <Table.Cell singleLine>{c.targetQualificationId}</Table.Cell>
                            <Table.Cell singleLine>{c.crewMemberName}</Table.Cell>
                            <Table.Cell singleLine>
                                {
                                    TranslateProps(changeLogTypeOptions).find(
                                        x => x.value === c.type
                                    )?.text
                                }
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
            <TablePagination page={page} setPage={setPage} totalRows={totalRows} />
        </Segment>
    );
};
